import store from "@/store/index";
import { USER_ROLES } from "@/utils/constants";

// The landing route for each role, used whenever a guard turns a user away.
const homeRouteFor = role => {
  if (role === USER_ROLES.ADMIN) return "CreatePAAccount";
  if (role === USER_ROLES.OWNER) return "DedicatedCustomers";
  return "TaskDashboard";
};

// Allow only admin to access certain routes
export const requiresAdmin = (to, from, next) => {
  store
    .dispatch("authModule/actionGetUserDetails")
    .then(res => {
      // Previously only 'assistant' was turned away, so any other
      // non-admin role (Owner) fell through into the admin pages.
      if (res.role !== USER_ROLES.ADMIN) {
        next({ name: homeRouteFor(res.role) });
      } else {
        next();
      }
    })
    .catch(err => {
      if (err.response.status === 401) {
        store.dispatch("authModule/actionLogoutUser").then(() => {
          next({ name: "Login" });
        });
      }
    });
};

// Allow only PA to access certain routes
export const requiresPA = (to, from, next) => {
  store
    .dispatch("authModule/actionGetUserDetails")
    .then(res => {
      // Owners reach the shared customers list through these routes, so
      // they are allowed through here; the page itself renders read-only
      // and the API is customer-scoped server-side.
      const ownerAllowed = res.role === USER_ROLES.OWNER && !!to.meta.ownerAllowed;
      if (res.role === USER_ROLES.ADMIN) {
        next({ name: "CreatePAAccount" });
      } else if (res.role === USER_ROLES.OWNER && !ownerAllowed) {
        next({ name: homeRouteFor(res.role) });
      } else {
        next();
      }
    })
    .catch(err => {
      if (err.response.status === 401) {
        store.dispatch("authModule/actionLogoutUser").then(() => {
          next({ name: "Login" });
        });
      }
    });
};
